import {
  emailBlockSchema,
  type IEmailBlockSchema,
} from "@redotech/redo-marketing-templates-common/email-template";
import {
  savedEmailSectionSchema,
  type ISavedEmailSection,
} from "@redotech/redo-marketing-templates-common/saved-email-section";
import * as z from "zod";

export const createSavedEmailSection = {
  name: "createSavedEmailSection" as const,
  input: z.object({
    name: z.string(),
    blocks: z.array(emailBlockSchema as IEmailBlockSchema),
  }),
  output: savedEmailSectionSchema as ISavedEmailSection,
};
